var map = {
	"./WhatsApp Image 2025-01-30 at 1.36.00 PM (1).jpeg": 97614,
	"./WhatsApp Image 2025-01-30 at 1.36.00 PM.jpeg": 51092,
	"./WhatsApp Image 2025-01-30 at 1.36.01 PM (1).jpeg": 26247,
	"./WhatsApp Image 2025-01-30 at 1.36.01 PM.jpeg": 10257,
	"./WhatsApp Image 2025-01-30 at 1.36.02 PM.jpeg": 89686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70465;